import {
  TOKEN_CONFIG_ROOT,
  TOKEN_CONFIG_PBK,
  TOKEN_TRANS_SINGLE_USE_TIME_BOUNDED,
  TOKEN_TRANS_REPEAT_USE_TIME_BOUNDED,
  TOKEN_TRANS_SINGLE_USE_TIME_UNBOUNDED,
  TOKEN_TRANS_PERIODIC_USE_TIME_BOUNDED,
  TOKEN_CONFIG_TAG,
  TOKEN_REMOVE_TAG,
  TOKEN_SERVICE,
  APP_SMART_LOCKER_SHARE,
  APP_SMART_LOCK_SHARE,
} from "./Constants";
const crypto = require("crypto");
const base64url = require("base64url");

class Token {
  constructor(tok, privateKey) {
    this.mPrivateKey = privateKey;
    const jwt = this.parseJWT(tok);
    const header = JSON.parse(jwt.payload);
    this.app = header.a;
    this.tokenType = header.b;
    this.tokens = [];

    switch (this.tokenType) {
      case TOKEN_CONFIG_ROOT:
        this.RootConfig(jwt);
        break;
      case TOKEN_CONFIG_PBK:
        this.PbkConfig(jwt);
        break;
      case TOKEN_CONFIG_TAG:
      case TOKEN_REMOVE_TAG:
        this.TagConfig(jwt);
        break;
      case TOKEN_TRANS_SINGLE_USE_TIME_BOUNDED:
      case TOKEN_TRANS_REPEAT_USE_TIME_BOUNDED:
      case TOKEN_TRANS_SINGLE_USE_TIME_UNBOUNDED:
      case TOKEN_TRANS_PERIODIC_USE_TIME_BOUNDED:
        if (this.app === APP_SMART_LOCKER_SHARE) {
          this.SmartLockerShareTransaction(jwt);
        } else if (this.app === APP_SMART_LOCK_SHARE) {
          this.SmartLockShareTransaction(jwt);
        }
        break;
      case TOKEN_SERVICE:
        break;
      default:
        break;
    }
  }

  parseJWT(token) {
    const parts = token.split(".");
    return {
      header: JSON.parse(base64url.decode(parts[0])),
      payload: base64url.decode(parts[1]),
      signature: base64url.decode(parts[2]),
    };
  }

  RootConfig(jwt) {
    console.log("RootConfig:", jwt.payload);
    const data = JSON.parse(jwt.payload);
    this.btAdvId = data.c;
    this.btAddr = data.d;
    this.btRssiMax = data.e;
    this.btRssiMin = data.f;
    this.tokens = [data.g, data.h];
  }

  TagConfig(jwt) {
    console.log("TagConfig:", jwt.payload);
    const data = JSON.parse(jwt.payload);
    this.btAdvId = data.c;
    this.btAddr = data.d;
    this.btRssiMax = data.e;
    this.btRssiMin = data.f;
    this.tokens = [data.g];
  }

  PbkConfig(jwt) {
    console.log("PbkConfig:", jwt.payload);
    const data = JSON.parse(jwt.payload);
    this.btAdvId = data.c;
    this.btAddr = data.d;
    this.btRssiMax = data.e;
    this.btRssiMin = data.f;
    this.tokens = [
      data.g,
      data.h,
      data.i,
      data.j,
      data.k,
      data.l,
      data.m,
      data.n,
    ];
  }

  SmartLockerShareTransaction(jwt) {
    console.log("SmartLockerShareTransaction");
    const data = JSON.parse(jwt.payload);
    this.tokenData = data.c;
    this.btAdvId = data.d;
    this.btAddr = data.e;
    this.btRssiMax = data.f;
    this.btRssiMin = data.g;
    this.orderId = data.h;
    this.transId = data.i;
    this.assetId = data.j;
  }

  SmartLockShareTransaction(jwt) {
    console.log("SmartLockShareTransaction");
    const data = JSON.parse(jwt.payload);
    this.tokenData = data.c;
    this.btAdvId = data.d;
    this.btAddr = data.e;
    this.btRssiMax = data.f;
    this.btRssiMin = data.g;
    this.orderId = data.h;
    this.transId = data.i;
    this.assetId = data.j;
  }

  RSADecrypt(eData, privateKey) {
    const decryptedData = crypto.privateDecrypt(
      {
        key: privateKey,
        padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
        oaepHash: "sha256",
      },
      Buffer.from(eData, "base64")
    );

    return decryptedData;
  }

  dump() {
    console.log("--------- Token ---------");
    console.log("app:", this.app);
    console.log("tokenType:", this.tokenType);
    console.log("tokenData:", this.tokenData);
    for (let i = 0; i < 2; i++) {
      console.log(`Config token${i}:`, this.tokens[i]);
    }
    console.log("btAdvId:", this.btAdvId);
    console.log("btAddr:", this.btAddr);
    console.log("btRssiMax:", this.btRssiMax);
    console.log("btRssiMin:", this.btRssiMin);
    console.log("orderId:", this.orderId);
    console.log("transId:", this.transId);
    console.log("assetId:", this.assetId);
    console.log("--------------------------");
  }
}

export default Token;
